import React from "react";
import { StageSpinner } from "react-spinners-kit";

// The Roster component matches one of two different routes
// depending on the full pathname
export default function Loading() {
  return (
    <div className="" style={styles.containerStyle}>
        <StageSpinner size={100} color="#26b9d3" loading={true} />
    </div>
  );
}

const styles = {
  containerStyle: {
    display: "flex",
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(0,0,0,0.1)",
  }
} 
